/**
 * Reusable fullscreen quad for post-processing passes.
 * Two triangles covering clip space (-1 to 1).
 * Shared by BloomPass and RenderPipeline.
 */
export class FullscreenQuad {
  private _gl: WebGL2RenderingContext;
  private _vao: WebGLVertexArrayObject;
  private _vbo: WebGLBuffer;

  constructor(gl: WebGL2RenderingContext) {
    this._gl = gl;
    this._vao = gl.createVertexArray()!;
    this._vbo = gl.createBuffer()!;

    const verts = new Float32Array([
      -1, -1,  0, 0,
       1, -1,  1, 0,
       1,  1,  1, 1,
      -1, -1,  0, 0,
       1,  1,  1, 1,
      -1,  1,  0, 1,
    ]);

    gl.bindVertexArray(this._vao);
    gl.bindBuffer(gl.ARRAY_BUFFER, this._vbo);
    gl.bufferData(gl.ARRAY_BUFFER, verts, gl.STATIC_DRAW);

    gl.enableVertexAttribArray(0);
    gl.vertexAttribPointer(0, 2, gl.FLOAT, false, 16, 0);
    gl.enableVertexAttribArray(1);
    gl.vertexAttribPointer(1, 2, gl.FLOAT, false, 16, 8);

    gl.bindVertexArray(null);
  }

  draw(): void {
    this._gl.bindVertexArray(this._vao);
    this._gl.drawArrays(this._gl.TRIANGLES, 0, 6);
    this._gl.bindVertexArray(null);
  }

  dispose(): void {
    this._gl.deleteVertexArray(this._vao);
    this._gl.deleteBuffer(this._vbo);
  }
}
